const INITIAL_STATE = {
  data: {},
  errors: {},
  keydata:{}
            
}
const OptimorouteKey = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_OPTIMOROUTE_KEY_SUCCESSFULLY':
    return { ...INITIAL_STATE, keydata: action.data }
  case 'GET_OPTIMOROUTE_KEY_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_OPTIMOROUTE_KEY_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'UPDATE_OPTIMOROUTE_KEY_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
            
export default OptimorouteKey;